<template>
  <div class="dialog-wrap">
    <div class="mask"></div>
    <div class="content">
      <div class="title">请选择打赏金额</div>
      <div>
        <div class="col">
          <div class="item" v-for="v in configV" :key="v" :class="{active: amount==v}" @click="fastInput(v)">{{v}}元</div>
        </div>
      </div>
      <div class="haha">土豪请随意</div>
      <div class="input-wrap">
        <span class="iconfont icon-renminbi1"></span>
        <input type="number" placeholder="" v-model="amount">
      </div>
      <div class="btns">
        <div @click="shang">打赏</div>
      </div>
      <div class="close" @click="close"><!-- 关闭按钮 --><i class="iconfont icon-guanbi"></i></div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import config from '@/utils/config'
import {mapGetters} from 'vuex'
export default {
  props: {
    videoId: {
      type: String,
      default: ''
    },
    courseId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      amount: '', // 应该是数字0,空串为了显示好看
      configV: [0.88, 1.88, 6.66, 8.88]
    }
  },
  computed: {
    ...mapGetters({
      isWeixin: 'isWeixin'
    })
  },
  methods: {
    fastInput(v) {
      this.amount = v
    },
    close() {
      this.$emit('close')
    },
    shang() {
      // eslint-disable-next-line
      if (Number(this.amount) > 0 && Number(this.amount) == this.amount && /^([1-9]+[\d]*|0(?=\.))(\.[\d]{1,2})?$/g.test(this.amount)) {
        // eslint-disable-next-line
        let commonUrl = '?goods_id=' + this.courseId + '&payment_type=4&video_id=' + this.videoId + '&amount=' + this.amount + '&anchor=' + this.$route.path
        let wxUrl = 'index/index/pay/' + commonUrl
        let h5Url = 'index/index/pay/' + commonUrl + '&payment_platform=MWEB'
        let padUrl = 'index/index/qrpay/' + commonUrl
        // 获取设备类型
        // DEVICE_TYPE: wechat, h5, pad
        const DEVICE_TYPE = localStorage.getItem('device_type')
        let webDomain = localStorage.getItem('web_domain') || config.host
        if (DEVICE_TYPE === 'wechat') {
          window.location.href = webDomain + wxUrl
          console.log(webDomain + wxUrl)
        } else if (DEVICE_TYPE === 'h5') {
          window.location.href = webDomain + h5Url
          console.log(webDomain + h5Url)
        } else if (DEVICE_TYPE === 'pad') {
          window.location.href = webDomain + padUrl
          console.log(webDomain + padUrl)
        }
      } else {
        this.$toast('请输入正确金额')
      }
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .dialog-wrap{
    width: 100%
    .mask{
      display block
      position fixed
      top: 0
      bottom 0
      left 0
      right 0
      z-index 999
      background-color: rgba(0, 0, 0, .5)
    }
    .content{
      text-align center
      font-size size(28)
      position fixed
      top 50%
      left 50%
      z-index 9999
      transform translate(-50%, -50%)
      width size(540)
      background-color #fff
      padding 0 size(30)
      border-radius size(10)
      .title{
        line-height size(126)
        font-size size(34)
        font-weight 800
      }
      .col{
        display flex
        justify-content: space-between;
        text-align center
        flex-wrap wrap
        .item{
          width size(222)
          color #fff
          font-size size(30)
          border 1px solid #e6e6e6
          color #333
          border-radius 4px
          line-height size(60)
          margin-bottom size(18)
          &.active{
            border-color $color-theme
            background $color-theme
            color #fff
          }
        }
      }
      .haha{
        font-size size(30)
        font-weight 800
        text-align left
        margin size(30) 0 size(18)
      }
      .input-wrap{
        display flex
        padding 0 size(12)
        align-items center
        border: 1px solid #eee
        -webkit-border-radius: size(6)
        border-radius: size(6)
        input{
          font-size size(26)
          flex 1
          padding size(16)
          appearance: none
          -webkit-appearance: none
          outline none
        }
        .iconfont{
          color #999
          font-size 14px
          position relative
          top 1.5px
        }
      }
      .btns{
        position: relative
        margin-top: size(50)
        line-height size(88)
        text-align center
        color $color-theme
        font-size size(30)
      }
      .btns:before{
        position: absolute;
        right: size(-30);
        top: 0;
        left: size(-30);
        height: 1px;
        content: '';
        transform: scaleY(0.5);
        background-color: #e6e6e6
      }
      .close{
        position absolute
        right 0
        top 0
        padding size(30)
        color #999
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/play/play-dashang-dialog.vue